import { getV3Key } from './recaptchaKey';

export const recaptchaScript = () => {
  const script = document.createElement('script')

  script.src = `https://www.google.com/recaptcha/api.js?render=${getV3Key()}`

  document.head.appendChild(script)
}